module.exports = __webpack_public_path__ + "static/img/member250107EN.0ebd879.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member250107EN.jpg
// module id = me0G
// module chunks = 1